module.exports = __webpack_public_path__ + "static/media/Slack_Mark_Monochrome_White.eb83761a.svg";